import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { Accordion, Form, Grid, Icon } from 'semantic-ui-react';

import { DatePickerField, InputField } from 'Common/SemanticWrapper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { CreateEditPurchaseOrderEnum } from 'Common/FieldEnum';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import { ItemGridFormField, DatePickerCustomButton } from 'Components';
import { OrdertypeEnum } from 'Common/Constants/Enumeration/ManagePurchaseOrderEnum';

import {
  getTotalMerchandiseAmount,
  getTotalCostAmount,
  getTotalTaxCostAmount,
} from './../../helper';

const CreateEditPurchaseOrderComponent = props => {

  const {
    isDisabled,
    editPOWOItems,
    fetchEditPOWOItems,
    poItemDetails,
    onResetPageOnDataChange,
    resetPageOnDataChange,
    activeIndexForFilter,
    handleClick,
    isEditPage,
    IsWarehouseOrder,
    selectedOrderDetail,
  } = props;

  return (
    <Form>
      <Grid>
        <Accordion fluid styled>
          <Accordion.Title
            active={!activeIndexForFilter}
            index={0}
            onClick={handleClick}
          >
            <Icon name="dropdown" />
          </Accordion.Title>
          <Accordion.Content active={!activeIndexForFilter}>
            <Grid className={'remove-spacing'}>
              <Grid.Row columns={4}>
                <Grid.Column>
                  <Field
                    component={InputField}
                    label={
                      IsWarehouseOrder === OrdertypeEnum.PO
                        ? 'PO #'
                        : IsWarehouseOrder === OrdertypeEnum.WO
                        ? 'WO #'
                        : 'KO #'
                    }
                    name={CreateEditPurchaseOrderEnum.PONum}
                    type={'text'}
                    disabled={true}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={DatePickerField}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    label={
                      IsWarehouseOrder === OrdertypeEnum.PO
                        ? 'PO Date'
                        : IsWarehouseOrder === OrdertypeEnum.WO
                        ? 'WO Date'
                        : 'KO Date'
                    }
                    name={CreateEditPurchaseOrderEnum.PODate}
                    type={'text'}
                    customInput={<DatePickerCustomButton isDisabled={true} />}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={DatePickerField}
                    dateFormat={DATE_FORMAT_FOR_UI}
                    label={'Delivery Date'}
                    name={CreateEditPurchaseOrderEnum.DeliveryDT}
                    type={'text'}
                    customInput={<DatePickerCustomButton isDisabled={true} />}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    name={CreateEditPurchaseOrderEnum.VendorName}
                    component={InputField}
                    type={'text'}
                    label={'Distributor'}
                    disabled={true}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={4}>
                <Grid.Column>
                  <Field
                    component={InputField}
                    label={'ORDER #'}
                    name={CreateEditPurchaseOrderEnum.OrderIds}
                    type={'text'}
                    disabled={true}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={InputField}
                    label={'Site'}
                    name={CreateEditPurchaseOrderEnum.SiteName}
                    type={'text'}
                    disabled={true}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={InputField}
                    label={'BUDGET CODE'}
                    name={CreateEditPurchaseOrderEnum.BudgetCode}
                    type={'text'}
                    disabled={true}
                  />
                </Grid.Column>
                <Grid.Column>
                  <Field
                    component={InputField}
                    label={'ENCUMBRANCE CODE'}
                    name={CreateEditPurchaseOrderEnum.EncumbranceCode}
                    type={'text'}
                    disabled={true}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2}>
                <Grid.Column width={8}>
                  <Field
                    name={CreateEditPurchaseOrderEnum.Comments}
                    component={InputField}
                    type={'text'}
                    maxLength={50}
                    label={'Comments'}
                    disabled={isDisabled}
                  />
                </Grid.Column>
                <Grid.Column width={4}>
                  <Field
                    component={InputField}
                    label={'SHIPPING COST ($)'}
                    name={CreateEditPurchaseOrderEnum.ShippingCost}
                    type={'text'}
                    disabled={true}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Accordion.Content>
        </Accordion>
        <Grid.Row columns={4}>
          <Grid.Column width={3}>
            <label className={'text-orange'}>
              Order Items(
              {poItemDetails && poItemDetails.length})
            </label>
          </Grid.Column>
          <Grid.Column width={5}>
            <label className={'text-orange'}>
              Total merchandise cost: <Icon name={'dollar'} />
              {getTotalMerchandiseAmount(poItemDetails)}
            </label>
          </Grid.Column>
          <Grid.Column width={5}>
            <label className={'text-orange'}>
              Total tax cost: <Icon name={'dollar'} />
              {getTotalTaxCostAmount(poItemDetails)}
            </label>
          </Grid.Column>
          <Grid.Column width={3}>
            <label className={'text-orange'}>
              Total cost: <Icon name={'dollar'} />
              {getTotalCostAmount(poItemDetails)}
            </label>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Field
              component={ItemGridFormField}
              name={CreateEditPurchaseOrderEnum.POItemDetails}
              {...{
                dataSource:
                  isDisabled || IsWarehouseOrder !== OrdertypeEnum.PO
                    ? selectedOrderDetail[
                      CreateEditPurchaseOrderEnum.POItemDetails
                      ]
                    : editPOWOItems,
                fetchingOrderItems: fetchEditPOWOItems,
                isPreviewPage: false,
                disabled:
                  isDisabled ||
                  (isEditPage && IsWarehouseOrder !== OrdertypeEnum.PO),
                gridName: GridEnum.INV_ManagePurchaseOrder_CreateEdit_View,
                tableName: TableNamesEnum.PURCHASE_ORDER_CREATE_EDIT_TABLE,
                onResetPageOnDataChange: onResetPageOnDataChange,
                resetPageOnDataChange: resetPageOnDataChange,
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

CreateEditPurchaseOrderComponent.propTypes = {
  isDisabled: PropTypes.bool,
  editPOWOItems: PropTypes.array,
  fetchEditPOWOItems: PropTypes.bool,
  poItemDetails: PropTypes.array,
  onResetPageOnDataChange: PropTypes.func,
  resetPageOnDataChange: PropTypes.bool,
  isEditPage: PropTypes.bool,
};

CreateEditPurchaseOrderComponent.defaultProps = {
  isDisabled: false,
  editPOWOItems: [],
  fetchEditPOWOItems: false,
  poItemDetails: [],
  onResetPageOnDataChange: () => {},
  resetPageOnDataChange: false,
  isEditPage: false,
};

export default CreateEditPurchaseOrderComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/managepurchaseorder/components/createEditPurchaseOrder/CreateEditPurchaseOrder.js